<template>
  <div id="contenedor-registrar-nueva-deduccion">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevaDeduccion">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva deduccion
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              v-model="deduccion.nombre"
              label="Nombre"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <custom-text-field
              v-model.number="deduccion.porcentaje"
              label="Porcentaje"
              type="number"
              suffix="%"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarDeduccion"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoDeducciones from './mixCatalogoDeducciones';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'RegistrarNuevaDeduccion',
  mixins: [mixCatalogoDeducciones],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      deduccion: {
        nombre: '',
        porcentaje: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaDeduccion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
